module.exports = __webpack_public_path__ + "img/podium_3075.f685b10a.jpg";